import styled from "styled-components";

export const PreviewStyles = styled.div`
  margin-top: 31px;
  width: 100%;
  max-width: 1140px;
  margin: 0 auto 80px;
  padding: 0 10px;
  @media (max-width: 900px) {
    max-width: 400px;
  }
`;

export const PreviewIcon = styled.img`
  display: inline-block;
  width: 130px;
  height: 55px;
  @media (max-width: 900px) {
    width: 80px;
    height: 34px;
  }
`;

export const PreviewLogo = styled.div`
  align-items: center;
  max-width: 300px;
  margin: 0 auto 60px;
`;

export const HeaderStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PhonePreview = styled.img`
  display: inline-block;
  width: 24px;
  height: 24px;
  @media (max-width: 900px) {
    width: 16px;
    height: 16px;
  }
`;

export const BodyStyles = styled.div`
  padding-top: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .button-prepay {
    width: 280px;
  }
  @media (max-width: 900px) {
    padding: 0 10px;
    flex-direction: column;
    text-align: center;
  }
  .money {
    color: var(--glz-color-success);
    @media (max-width: 900px) {
      padding-left: 5px;
    }
  }
`;

export const CalculateLogo = styled.img`
  display: inline-block;
  width: 488px;
  height: 532px;
  @media (max-width: 900px) {
    width: 320px;
    height: 348px;
  }
`;

export const FuelLogo = styled.img`
  display: inline-block;
  width: 609px;
  height: 395px;
  margin-right: -80px;
  @media (max-width: 900px) {
    width: 346px;
    height: 234px;
    margin-right: -12px;
  }
`;

export const Title = styled.div`
  color: var(--glz-color-neutral-tone-4);
  font-size: 14px;
  @media (max-width: 900px) {
    padding-top: 27px;
  }
`;

export const NameCompanyStyle = styled.div`
  font-size: 40px;
  font-weight: 700;
  @media (max-width: 900px) {
    font-size: 28px;
  }
`;

export const DescriptionStyle = styled.div`
  font-size: 22px;
  line-height: 33px;
  font-weight: 400;
  @media (max-width: 900px) {
    font-size: 16px;
  }
`;

export const PhoneStyle = styled.div`
  display: flex;
  align-items: center;
  .phone {
    font-size: 18px;
    padding-left: 15px;
    :hover {
      color: var(--glz-color-neutral-tone-5);
      text-decoration: none;
    }
    @media (max-width: 900px) {
      font-size: 16px;
      padding-left: 6px;
    }
  }
`;

export const WrapperButton = styled.div`
  display: flex;
  padding: 30px 0px;
  align-items: center;
  @media (max-width: 900px) {
    flex-direction: column;
    padding: 0px 0px 24px;
  }
  .button {
    max-width: 250px;
  }
`;

export const ButtonDescriptionStyle = styled.div`
  flex-direction: column;
  font-size: 18px;
  padding-left: 26px;
  font-weight: 600;

  @media (max-width: 900px) {
    flex-direction: row;
    padding: 12px 0px 0px;
  }
  .minutes {
    color: var(--glz-color-primary);
    @media (max-width: 900px) {
      padding-left: 5px;
    }
  }
`;

export const PhoneNumnerStyle = styled.div``;
